/* eslint no-console: "off" */
import Vue from 'vue';
import axios from 'axios';
import VueGtm from 'vue-gtm';
import ProgressBar from 'progressbar.js';
import App from './App';
import router from './router';
import store from './store';
import auth from './common/auth';

Vue.config.devtools = false;
Vue.config.productionTip = false;
// define Vue property of $axios with the value of axios in order to use it like this: "this.$axios.get..."
Object.defineProperty(Vue.prototype, '$axios', { value: axios });

axios.interceptors.request.use((config) => {
  // eslint-disable-next-line
  config.url = window.location.origin + '/' + config.url;
  return config;
}, (error) => { Promise.reject(error); });

if (sessionStorage.getItem('splashScreenProgrammaticallyRefresh') !== true) {
  sessionStorage.setItem('splashScreenAlreadyDisplayed', 'false');
}
router.beforeEach((to, from, next) => {
  // eslint-disable-next-line
  $('body').removeClass();
  // eslint-disable-next-line
  $('body').addClass('ui_' + to.name);
  console.log('==> in global before each:');
  sessionStorage.setItem('toPage', to.fullPath);
  if (to.query.fb_ref) {
    const fbRef = to.query.fb_ref;
    store.commit({ type: 'common/facebookReferral', fbRef });
  }
  // http://localhost:9090/#/?lang=ar
  if (to.query.lang === 'ar' || to.query.lang === 'AR') {
    const currentLocale = to.query.lang;
    store.dispatch({ type: 'i18n/methodTochangeLocales', currentLocale });
  } else if (to.query.lang === 'en' || to.query.lang === 'EN') {
    const currentLocale = to.query.lang;
    store.dispatch({ type: 'i18n/methodTochangeLocales', currentLocale });
  }
  if (!localStorage.getItem('locale')) {
    const currentLocale = store.getters['i18n/getDefaultLanguage'];
    store.dispatch({ type: 'i18n/methodTochangeLocales', currentLocale });
  }
  if (!store.getters['common/getClickId']) {
    const clickid = to.query.clickid;
    store.commit({ type: 'common/storeClickid', clickid });
  }
  if (!store.getters['common/getCampaignId']) {
    const campaignId = to.query.campaignId;
    store.commit({ type: 'common/updateCampaignId', campaignId });
  }
  if (!store.getters['common/getPublisherId']) {
    const publisherId = to.query.publisherId;
    store.commit({ type: 'common/updatePublisherId', publisherId });
  }
  if (to.query.banner) {
    const bannerImgName = to.query.banner;
    store.commit({ type: 'common/storeBanner', value: bannerImgName });
  }
  if (!store.getters['common/getRefUrl']) {
    const refUrl = to.query.refUrl;
    store.commit({ type: 'common/updateRefUrl', refUrl });
    // check if refUrl is Blocked from DB and make a call only if refUrl exists
    if (to.query.refUrl && to.query.refUrl !== '') { // check if refUrl is undefined or empty
      const dataAdv = {
        refUrl: to.query.refUrl,
        publisherId: to.query.publisherId,
      };
      store.dispatch({ type: 'common/checkIfURLisBlocked', value: dataAdv }).then((response) => {
        console.log('response.data.responseEnum');
        console.log(response.data.responseEnum);
        if (response.data.responseEnum === 'SERVER_ERROR' || response.data.responseEnum === 'BLOCKED_USER') {
          console.log('Go to an errorpage EXC-2474');
          store.commit({ type: 'common/updateRefUrl' });
          next({ path: '/error' });
        } else {
          // eslint-disable-next-line
          if (!store.getters['common/getCPC'] && to.query.cpc && to.query.refUrl) {
            const cpc = to.query.cpc;
            store.commit({ type: 'common/updateCPC', cpc });
            const dataAdve = {
              refUrl: to.query.refUrl,
              publisherId: to.query.publisherId,
              cpc: to.query.cpc,
              clickid: to.query.clickid,
            };
            store.dispatch({ type: 'common/saveCPC', value: dataAdve }).then(() => {
              console.log('CPC updated in BI_CPC_VARIATIONS');
            });
          }
        }
      });
    } else {
      store.commit({ type: 'common/updateRefUrl', refUrl: to.query.affiliate_name }); // EXC-4232 - affise integration
    }
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    console.log(`from.path: ${from.path}`);
    console.log(`to.path: ${to.path}`);
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (auth.checkAuth()) {
      const splitPath = to.path.split('/');
      if (splitPath[1] === 'searchingOpponent') {
        if (Object.keys(store.state.common.GameTypesEnums).includes(splitPath[2]) &&
          Object.keys(store.state.common.GameModesEnums).includes(splitPath[3])) {
          console.log('User Tries to navigate to searchingOpponent');
          store.dispatch({ type: 'common/proceedWithSearchingOpponent' }).then(() => {
            if ((store.state.common.userDetails.availableGames === 0) || (store.state.game.gameInProgress)) {
              console.log('User cannot navigate searchingOpponent page');
              next({ path: '/home' });
            } else {
              next();
            }
          });
        } else next({ path: '/home' });
      } else {
        // if a game page was refreshed redirect to home page
        console.log(`User ${store.state.common.userDetails.username} has valid jwt Token and want to go from free to logged or refresh page`);
        if (!store.state.common.userDetails.username) {
          console.log('getUserLoginDetails has triggered');
          store.dispatch({ type: 'profile/getUserLoginDetails' }).then(() => {
            console.log(`User is ${store.state.profile.userAuthorized} to proceed`);
            next();
          });
        } else {
          next();
        }
      }
    } else {
      next({ path: '/login' });
    }
  } else {
    // eslint-disable-next-line
    if (auth.checkAuth()) {
      console.log('JWT enabled and user wants to go to free pages and needs the userDetails from Duel db');
      if (to.query.code) {
        const code = to.query.code;
        store.dispatch({ type: 'common/checkIfLinkIsValid', code }).then((response) => {
          const nextPage = response.data.responseEnum;
          // logout user
          let currentLocale = localStorage.getItem('locale');
          if (!currentLocale) currentLocale = store.state.i18n.currentLocale;
          const soundsOn = localStorage.getItem('soundsOn');
          localStorage.clear();
          localStorage.setItem('locale', currentLocale);
          localStorage.setItem('soundsOn', soundsOn);
          sessionStorage.clear();
          store.commit('profile/clearAllData');
          if (nextPage === 'LINK_EXPIRED') {
            store.commit('common/validTransitionForFreeGameMethod', true);
            next({ path: '/expiredLink' });
          } else if (nextPage === 'OPERATION_SUCCESS') {
            next({ path: '/gameIndex' });
          } else {
            next({ path: '/' });
          }
        }).catch((error) => {
          console.log(`Invoking api/checkIfLinkIsValid failed with the following error: ${error}`);
          next({ path: '/home' });
        });
      } else {
        next({ path: '/home' });
      }
    } else {
      console.log('not, REQUIRES AUTH');
      if (to.query.code) {
        const code = to.query.code;
        store.dispatch({ type: 'common/checkIfLinkIsValid', code }).then((response) => {
          const nextPage = response.data.responseEnum;
          if (nextPage === 'LINK_EXPIRED') {
            store.commit('common/validTransitionForFreeGameMethod', true);
            next({ path: '/expiredLink' });
          } else if (nextPage === 'OPERATION_SUCCESS') {
            next({ path: '/gameIndex' });
          } else {
            next({ path: '/' });
          }
        }).catch((error) => {
          console.log(`Invoking api/checkIfLinkIsValid failed with the following error: ${error}`);
          next({ path: '/' });
        });
      } else {
        next(); // make sure to always call next()!
      }
    }
  }
});

Vue.use(ProgressBar);

Vue.use(VueGtm, {
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false
  debug: false, // Whether or not display console logs debugs (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
});

store.dispatch('common/getRequiredServerData')
  .then(() => {
    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      router,
      auth,
      store,
      template: '<App/>',
      components: { App },
    });
  });



// WEBPACK FOOTER //
// ./src/main.js